import moment from '@/plugins/moment';
import { toCamelCaseProperties } from '@/utils/fn';
import UmbracoBase from './UmbracoBase';

export default class SearchAndCoverImage extends UmbracoBase {
	constructor(args) {
		super(args); // Extending UmbracoBase
		args = toCamelCaseProperties(args) || {};

		this.componentName = 'search-and-cover-image';
		this.title = args.title || 'Finn din favorittsalong';
		this.subTitle = args.subTitle || 'rask og enkel timebestilling';
		this.searchButtonText = args.soekeknapp || 'Søk og bestill';
		this.searchText = args.soeketekst || 'Søk etter sted eller salong';
		this.images = (args.bildesekvens || []).map(image => new CoverImage(image));
		this.settings = new Settings(args);
	}
}

export class CoverImage {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};
		const transform = `?anchor=center&mode=crop&width=${this.width}&height=${this.height}&rnd=${String(
			moment()
				.startOf('minute')
				.valueOf()
		)}`; // 1 minute cache

		this.name = args.urlName || '';
		this.key = args.key || '';
		this.src = `${window.UMBRACO.baseUrl}${args.url}${transform}`;
		this.isLoaded = false;
	}

	get height() {
		return 450;
	}

	get width() {
		return 500;
	}
}

export class Settings {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};

		this.displayAnimations = !!args.displayAnimations;
		this.displayDiagonalImages = !!args.displayDiagonalImages;
		this.imageDuration = args.visningsvarighet || 3000;
		this.imageTransitionDuration = args.overgangsvarighet || 300;
	}
}
